/**
 * 無人チェックイン共通変数、関数設定
 */
import { memberNumberMixin } from './memberNumberMixin';
import { GET_MEMBER_RANK } from '../../constants/mypage_side_menu';
import { GET_GOLFCOURSE_VISIT } from '../../constants/golf_course';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';

export default {
    mixins: [
        memberNumberMixin
    ],
    data () {
        return {
            // コード表示フラグ
            qr_show: false,
            barcode_show: false,
            page_title: '',
            icon_class: '',
            // WEB会員ID
            member_number: '',
            // WEB会員種類
            member_rank: '',
            my_page_btn_flg: true,
            // API情報取得
            json_info: require('../../datas/visit_api.json'),
            api_url: false,
            api_key: '',
            api_office_code: '',
            qr_code: '',
            // エラーログの表示フラグ
            show_error: false,
            error_message: '',
            error_level: "crit",
            // ダイアログの表示フラグ
            add_dia_log: false,
            add_dia_log_message: '',
            add_dia_log_doing: '確認',
            show_modal: false,
            // 表示コード種類
            make_display_code: '1',
            // ゴルフ場一覧
            golf_course: [],
            show_golf_list_flg: false,
            show_golf_list_count_flg: false,
            show_golf_list_count_restaurant_flg: false,
        };
    },
    beforeCreate () {
        // ローディング非表示
        this.$store.commit("loading/setIsLoading", true);

        return Promise.resolve()
            .then(function(){
                return new Promise(function(fulfilled, rejected){
                    // 会員番号を生成（ゴルフグループコード+会員番号0埋め8桁）
                    this.member_number = this.getReadableMemberNumberByScannerDevice(
                        process.env.MIX_GROUP_CODE,
                        this.$store.state.auth.loginMember.member_no,
                    );

                    this.$apollo.query({
                        query: GET_GOLFCOURSE_VISIT,
                        variables: {
                            golf_group_code: process.env.MIX_GROUP_CODE,
                            member_number: this.member_number
                        }
                    }).then(res => {
                        // ゴルフ場一覧格納
                        this.golf_course = res.data.golfCourseListByVisit;
                        for (var i = 0; i < this.golf_course.length; i++ ) {
                            this.golf_course[i].id = i + 1;

                            // ゴルフ場選択　レストラン用
                            if(this.golf_course[i].api_restaurant_url != undefined && this.golf_course[i].api_restaurant_url != '' && this.golf_course[i].api_restaurant_url != null){
                                this.show_golf_list_count_restaurant_flg = true;
                            }
                            // ゴルフ場選択　API用
                            if(this.golf_course[i].api_url != undefined && this.golf_course[i].api_url != '' && this.golf_course[i].api_url != null){
                                this.show_golf_list_count_flg = true;
                            }
                        }

                        return fulfilled(true);
                    })
                }.bind(this));
            }.bind(this)).then(function(){
                return this.GetMemberRank();
            }.bind(this)).then(function(){
                // ローディング非表示
                this.$store.commit("loading/setIsLoading", false);

                // レストランオーダー画面ではない場合はゴルフ場一覧を表示
                if(this.$route.path !== '/mypage-visit-restaurant'){
                    // ゴルフ場一覧表示
                    this.show_golf_list_flg = true;
                }else{
                    // 画面の情報読み込み開始
                    this.initialize();
                }
            }.bind(this));

    },
    methods: {
        initialize () {
        },
        /** ----------------------------------------------
         * WEB会員の種別を取得
         * ---------------------------------------------- */
        GetMemberRank: function () {
            return Promise.resolve()
                .then(function(){
                    return new Promise(function(fulfilled, rejected){
                        return this.$apollo.query({
                            query: GET_MEMBER_RANK,
                            variables: {
                                member_no: this.$store.state.auth.loginMember.member_no
                            }
                        }).then(res => {
                            this.member_rank = res.data.getMemberRankByMemberId.member_rank;
                            return fulfilled(true);
                        })
                    }.bind(this));
                }.bind(this));
        },
        /** ----------------------------------------------
         * バーコードを生成
         * ---------------------------------------------- */
        async makeDisplayBarCode(no) {
            // Promiseにて戻り値が来るまで動作停止
            await (() => {
                return new Promise((resolve) => {
                    JsBarcode("#barcode", no, {
                        format: "CODE39",
                        width: 2,
                        height: 150,
                        displayValue: false
                    });
                    this.barcode_show = true;
                    resolve(true);
                });
            })();
        },
        /** ----------------------------------------------
         * QRコードを生成
         * ---------------------------------------------- */
        async makeDisplayQrCode(number) {
            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);

            // QRコード生成
            this.qr_code = await (() => {
                // Promiseにて戻り値が来るまで動作停止
                return new Promise((resolve) => {
                    QRCode.toString(number, {type: 'svg'}, function (err, str) {
                        // Promiseに停止判定を送る
                        resolve(str);
                    });
                });
            })();

            // ローディング非表示
            this.$store.commit("loading/setIsOpacityLoading", false);
        },
        /** ----------------------------------------------
         * マイページへ遷移
         * ---------------------------------------------- */
        myPage: async function(){
            this.$router.push({ path: '/mypage' });
        },
        /** ----------------------------------------------
         * 選択したゴルフ場のAPIのURLを取得
         * ---------------------------------------------- */
        selectGolf: function(getApi, getKey, getOffice){
            this.add_dia_log = false;

            // 空ではない場合
            //if(getApi != undefined && getApi != '' && getApi != null){
                // ゴルフ場のAPI情報を使用
                this.api_url = getApi;
                this.api_key = getKey;
                this.api_office_code = getOffice;

            // ゴルフ場一覧非表示
            this.show_golf_list_flg = false;

            // 画面の情報読み込み開始
            this.initialize();
        },
    }
}